<ng-container *transloco="let t">
  <div class="flex h-[50vh] w-[60rem] flex-col gap-2">
    <div class="flex gap-4">
      <IInput
        size="sm"
        class="flex-1"
        type="text"
        placeholder="{{ t('sp-strategy-group-page.search_by_segment_name') }}"
        [(value)]="tacticSearchInput"
      />
      <IButton
        size="sm"
        label="{{ t('sp-strategy-group-page.new_tactic_label') }}"
        icon="icon-[material-symbols--add-rounded]"
        (onClick)="createTactic()"
      />
    </div>
    <div class="flex flex-1 flex-col gap-4 overflow-y-auto">
      @for (t of filteredTactics(); track t) {
        <div class="flex gap-2">
          <app-tactic
            class="w-full"
            [showKW]="true"
            [showProducts]="!modalData.strategy.disableProductSegment || t.tacticType === 'BLACKLIST'"
            [tactic]="t"
            [segment]="segmentIndex()?.get(t.segmentId)"
            [strategy]="modalData.strategy"
            (tacticDeleted)="tacticDeleted(t)"
          />
        </div>
      } @empty {
        @if (tactics().length > 0) {
          <div class="flex h-full items-center justify-center">
            <lib-empty-state
              [title]="
                t('sp-strategy-group-page.no_tactic_label', { tactic: modalData.tacticType === TacticType.BLACKLIST })
              "
              [description]="t('strategy-page.no_tactic_description', { tactic: tacticSearchInput() })"
            />
          </div>
        }
      }
      @if (tactics().length === 0) {
        <div class="flex h-full items-center justify-center">
          <lib-empty-state
            [title]="
              t('sp-strategy-group-page.no_tactic_label', { tactic: modalData.tacticType === TacticType.BLACKLIST })
            "
          />
        </div>
      }
    </div>
  </div>
</ng-container>
